
export const apiUrl =
  window.location.hostname.indexOf(".sharepark.net") > -1
    ? window.location.hostname.replace("admin", "api")
    : "localhost:5001";